import { AxiosError } from 'axios';

export default function isAxiosError<T = any>(payload: any): payload is AxiosError<T> {
  return typeof payload === 'object' && payload.isAxiosError === true;
}
